import 'element-plus/dist/index.css';
import './assets/css/normalize.css';
import './assets/css/skeleton.css';

import { createApp } from 'vue';
import { createPinia } from 'pinia';
/**
* $http plugin based on axios
*/
import {
  provideEventBus,
  useEventBus,
  config,
  TheMask,
  mask,
  Money3Component as money,
  http,
  httpPlugin,
} from 'apsis-plugin';
import { library } from '@fortawesome/fontawesome-svg-core';
import { FontAwesomeIcon, FontAwesomeLayers } from '@fortawesome/vue-fontawesome';
import { fas } from '@fortawesome/free-solid-svg-icons';
import { far } from '@fortawesome/free-regular-svg-icons';
import { fab } from '@fortawesome/free-brands-svg-icons';
import { abilitiesPlugin } from '@casl/vue';
import { Can } from 'apsis-component';
import ElementPlus from 'element-plus';
import ptBr from 'element-plus/dist/locale/pt-br.mjs';
import * as ElementPlusIconsVue from '@element-plus/icons-vue';

import './theme/index.css'; // #2D80DE / PLACEHOLDER: B0B4BC
import configureSubscribePinia from '@/app/login/vuex/subscribe';
import { mainStore } from './store';
import App from './App.vue';
import router from './router';
import ability from './app/login/ability';

// eslint-disable-next-line import/no-unresolved
import configCliente from './config.json';

const app = createApp(App);
provideEventBus(app); // Forneça o barramento de eventos para o aplicativo
const pinia = createPinia();

app.use(pinia);

configureSubscribePinia();

// ✅ works because the pinia instance is now active

// eslint-disable-next-line import/prefer-default-export
export const store = mainStore();
// import { ConfigApp, apiUrl } from '../config/configclient.copass';

/* eslint-disable no-undef */
/* eslint-disable no-multi-assign */
import('jquery').then((jQuery) => {
  window.$ = window.jQuery = jQuery.default;
}).catch((error) => {
  // eslint-disable-next-line no-console
  console.error('Erro ao carregar jQuery:', error);
});

// import { sync } from 'vuex-router-sync';
const environment = import.meta.env.VITE_APP_CFG_ENV === 'production' ? import.meta.env.VITE_APP_CFG_ENV : 'development';

// eslint-disable-next-line no-console
console.log('environment', environment);
const ConfigApp = configCliente[environment];
const apiUrl = import.meta.env.VITE_APP_API_URL;

// eslint-disable-next-line no-console
console.log(ConfigApp.cliente.id);
// eslint-disable-next-line no-console
console.log(apiUrl);
// eslint-disable-next-line no-console
console.log('**VUE 3**');

app.component('font-awesome-icon', FontAwesomeIcon);
app.component('font-awesome-layers', FontAwesomeLayers);
library.add(fas, far, fab);

// ativa $bus para todos componentes app
app.config.globalProperties.$bus = useEventBus;

// carrega a configuracao do cliente
app.use(config, { ConfigApp });

/**
* This package provides app plugin which defines $ability
* object and $can method for all components
*/

app.use(abilitiesPlugin, ability, {
  useGlobalProperties: true,
});

app.component('Permite', Can);

/**
* Make $http avaible to all components
* Send store and router to httpPlugin (injection)
*/

app.component('TheMask', TheMask);

app.component('money', money);

app.directive('mask', mask);

http.defaults.baseURL = apiUrl;

app.use(router);

app.use(httpPlugin, { store, router });

// Sincronização entre rotas e vuex.
// Garante o estado da store em todas as páginas SPA.
// sync(store, router);
app.config.devtools = import.meta.env.VITE_APP_CFG_ENV !== 'production';

// Google Analytics
// gtag('set', 'page', router.currentRoute.path);
// gtag('send', 'pageview');

/* eslint-disable no-unused-vars */
// router.afterEach((to, from) => {
//  gtag('set', 'page', to.path);
//  gtag('send', 'pageview');
// });

app.use(ElementPlus, {
  locale: ptBr,
});

for (const [key, component] of Object.entries(ElementPlusIconsVue)) {
  app.component(key, component);
}

app.mount('#app');
